import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { PERSONALISIERUNG_PUBLIC_PATH } from '@mcikm-vote/shared';
import type { PersonalisierungAntwort } from '@mcikm-vote/shared';

import { apiAnfrage } from '../api/anfrage';
import type { ApiFehler } from '../api/anfrage';

/**
 * Öffentlicher Abruf der Personalisierung (Änderungsanforderung ÄA-5).
 *
 * Wird von der Fußzeile, vom Kopflogo und von den Rechtstextseiten genutzt und braucht **keine**
 * Sitzung. Die Antwort enthält ausschließlich Personalisierungsangaben — keine Veranstaltung,
 * keinen Code, keinen Status (§9.1).
 *
 * Der Wert ändert sich fast nie; deshalb ein langer `staleTime` und kein Takt. Nach einer Änderung
 * im Verwaltungsbereich wird der Schlüssel dort ausdrücklich entwertet.
 *
 * **Ein Fehlschlag bleibt folgenlos.** Kopf und Fußzeile fallen dann auf das mitgelieferte
 * Markenlogo und die mitgelieferten Adressen zurück. Eine Anmeldeseite darf nicht davon abhängen,
 * dass diese Auskunft gelingt.
 */

export const PERSONALISIERUNG_SCHLUESSEL = ['personalisierung'] as const;

/** Eine Stunde. Der Wert wird von Hand gepflegt und ändert sich im Betrieb praktisch nicht. */
const HALTBARKEIT_MS = 60 * 60 * 1000;

export function usePersonalisierung(): UseQueryResult<PersonalisierungAntwort, ApiFehler> {
  return useQuery<PersonalisierungAntwort, ApiFehler>({
    queryKey: PERSONALISIERUNG_SCHLUESSEL,
    queryFn: () => apiAnfrage<PersonalisierungAntwort>(PERSONALISIERUNG_PUBLIC_PATH),
    staleTime: HALTBARKEIT_MS,
    // Ein Fehlschlag darf die Anmeldeseite nicht mit Wiederholungen belasten.
    retry: false,
  });
}
